var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-null"},[_c('van-image',{attrs:{"width":"7.2rem","height":"5.8rem","src":_vm.cartNull},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true}])}),_c('div',{staticStyle:{"margin-top":"0.5rem"}},[_vm._v("购物车里空空如也~")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }